import { render, staticRenderFns } from "./MedicalPopup.vue?vue&type=template&id=378c94b6"
import script from "./MedicalPopup.vue?vue&type=script&lang=js"
export * from "./MedicalPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports